import React from "react";

/**
 * Circle icon with minus at center. Usually to remove a line dynamically.
 */
const NotAllowHoriz = ({ onClick, color = "#DA8787" }: { onClick?: () => void, color?: string }) => (
  <svg cursor={"pointer"} width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1309_14399)">
      <path d="M19 0H0V19H19V0Z" fill="white" fillOpacity="0.01" />
      <path
        d="M9.49967 17.4163C13.8719 17.4163 17.4163 13.8719 17.4163 9.49967C17.4163 5.12742 13.8719 1.58301 9.49967 1.58301C5.12742 1.58301 1.58301 5.12742 1.58301 9.49967C1.58301 13.8719 5.12742 17.4163 9.49967 17.4163Z"
        stroke={color}
        strokeWidth="1.60444"
        strokeLinejoin="round"
      />
      <path
        d="M6.33301 9.5H12.6663"
        stroke={color}
        strokeWidth="1.60444"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1309_14399">
        <rect width="19" height="19" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default React.memo(NotAllowHoriz);
